import { getServicePlaceLabel } from './get-lot-location-label';

import { type LotType, ServicePlace, ServicePlaceLabel } from 'src/constants';
import type { IGetLocalization } from 'src/interfaces';

export const getSectionName = (
  section: string,
  getLocalization: IGetLocalization,
  lotType: LotType | null
) => {
  const sectionLabel = lotType
    ? getServicePlaceLabel(lotType, ServicePlace.SECTION)
    : ServicePlaceLabel[ServicePlace.SECTION];
  return section?.match(/^\d/) ? `${getLocalization(sectionLabel)} ${section}` : section;
};
